import {EmailDeliveryLogStatus} from 'src/openapi/admin/models/EmailDeliveryLog';

export const COLUMNS = {
    EMAIL_TYPE: 'email',
    STATUS: 'status',
    TIMESTAMP: 'statusChangeDate',
    INITIATOR: 'initiatorUser',
};

export const HEADERS = {
    [COLUMNS.EMAIL_TYPE]: 'Email Type',
    [COLUMNS.STATUS]: 'Status',
    [COLUMNS.TIMESTAMP]: 'Timestamp',
    [COLUMNS.INITIATOR]: 'Initiator',
};

export const STATUS_DESCRIPTIONS: Record<EmailDeliveryLogStatus, {title: string, description: string}> = {
    [EmailDeliveryLogStatus.PROCESSED]: {
        title: 'Processed',
        description: 'The email has been prepared for sending and queued for delivery',
    },
    [EmailDeliveryLogStatus.DEFERRED]: {
        title: 'Deferred',
        description: 'The email delivery has been temporarily delayed, but the system will retry later (e.g., due to the recipient\'s server being unavailable)',
    },
    [EmailDeliveryLogStatus.DELIVERED]: {
        title: 'Delivered',
        description: 'The email has been successfully delivered to the recipient',
    },
    [EmailDeliveryLogStatus.DROPPED]: {
        title: 'Dropped',
        description: 'The email was not sent due to internal rules or issues, such as the recipient\'s email being invalid or on a suppression list',
    },
    [EmailDeliveryLogStatus.BOUNCE]: {
        title: 'Bounce',
        description: 'The email was sent but rejected by the recipient\'s server, often due to an invalid address, a full mailbox, or server issues',
    },
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.EMAIL_TYPE,
        fixed: true,
        defaultWidth: 350,
        minWidth: 350,
        maxWidth: 350,
    },
    {
        columnId: COLUMNS.STATUS,
        fixed: false,
        defaultWidth: 150,
        minWidth: 150,
        maxWidth: 150,
    },
    {
        columnId: COLUMNS.INITIATOR,
        fixed: false,
        defaultWidth: 250,
        minWidth: 250,
        maxWidth: 250,
    },
    {
        columnId: COLUMNS.TIMESTAMP,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 200,
    },
];
